import { useAPI } from '../../state';
var UPDATE_TOU_API = '/api/user/tou';
export var useUpdateTouAPI = function () {
  return useAPI(UPDATE_TOU_API, undefined, 'PUT');
};